import React, { useState, useEffect } from "react";
import "../css/VideoBackground.css";
import {
  MDBIcon,
  MDBBtn,
  MDBContainer,
  MDBJumbotron,
  MDBCardImage,
  MDBCardTitle,
  MDBRow,
  MDBCol,
  MDBCard,
  MDBCardHeader,
  MDBCardText,
  MDBCardUp,
  MDBCardBody,
  MDBInput,
  MDBCardFooter,
  MDBFormInline,
} from "mdbreact";

import Axios from "axios";
import WarningBox from "../components/WarningBox";

import { Redirect } from "react-router-dom";

const OpenCashDrawer = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [userName, setUserName] = useState("");

  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const [cookies, setCookie] = useCookies(["authenticatedsession"]);

  const [frm, setValues] = useState({
    UserName: "",
    Password: "",
    agreed: true,
    cashier: sessionStorage.getItem("msal.uc"),
  });

  const [converted, setConversion] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    loginAccount();
  }

  const loginAccount = () => {
    if (props.apiServer === null) return;

    if (frm.UserName == "") {
      setErrorMessage("Please enter your username.");
      toggleWarningBox();
      return;
    }
    if (frm.Password == "") {
      setErrorMessage("Please enter your password.");
      toggleWarningBox();
      return;
    }

    const data = frm;
    Axios.post(props.apiServerPOS + "/opencashdrawer", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          //     setErrorMessage(res.data.message);
          //    toggleWarningBox(res.data.message);
          props.toggleModal();
        } else {
          setValues({ ...frm, UserName: "", Password: "" });

          setErrorMessage(res.data.message);
          toggleWarningBox();
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        toggleWarningBox();
      });
  };

  return (
    <React.Fragment>
      <MDBContainer className="text-center pt-3" fluid>
        {/* <MDBJumbotron> */}
        <MDBRow>
          <MDBCol>
            <br />
            <h2 className="h1 display-3  font-weight-bold blue-text">
              <MDBIcon icon="lock" className="red-text"></MDBIcon>&nbsp;ADMIN
              ACCESS
            </h2>

            <hr className="my-2" />

            <p>Enter your username and password to authenticate access:</p>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol md="4"></MDBCol>
          <MDBCol md="4">
            {/* <h6 className="h6 display-6  font-weight-bold black-text text-left">LOGIN FORM</h6> */}

            <form
              className="needs-validation"
              onSubmit={submitHandler}
              noValidate
            >
              <MDBRow className="pb-3 ">
                <MDBCol>
                  <div className="input-group">
                    <input
                      value={frm.UserName}
                      id="UserName"
                      type="text"
                      className="form-control"
                      placeholder="Username"
                      aria-label="Username"
                      aria-describedby="basic-addon"
                      required
                      onChange={updateField}
                    />

                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon">
                        <MDBIcon
                          icon="user"
                          size="1x"
                          className="prefix"
                        ></MDBIcon>
                      </span>
                    </div>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="pb-3">
                <MDBCol>
                  <div className="input-group">
                    <input
                      value={frm.Password}
                      id="Password"
                      type={passwordShown ? "text" : "password"}
                      className="form-control"
                      placeholder="Password"
                      aria-label="Password"
                      aria-describedby="basic-addon"
                      required
                      onChange={updateField}
                    />

                    <div className="input-group-prepend">
                      <span className="input-group-text" id="basic-addon">
                        <MDBIcon
                          icon="eye"
                          size="1x"
                          onClick={togglePasswordVisiblity}
                          className="prefix"
                        ></MDBIcon>
                      </span>
                    </div>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBBtn color="primary" type="submit">
                Login &nbsp;<MDBIcon icon="user"></MDBIcon>
              </MDBBtn>{" "}
              <MDBBtn
                className="cloudy-knoxville-gradient brown-text"
                type="button"
                onClick={props.toggleModal}
              >
                Close &nbsp;<MDBIcon icon="times"></MDBIcon>
              </MDBBtn>
            </form>
          </MDBCol>

          <MDBCol md="3"></MDBCol>
        </MDBRow>

        {/* </MDBJumbotron> */}
      </MDBContainer>

      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
    </React.Fragment>
  );
};

export default OpenCashDrawer;
